<div class="backgroundLogin"></div>
<div class="loginForm">
    <h2 [innerHtml]="'FORGOT_PASSWORD' | translate">Forgot password</h2>
    <form [formGroup]="passwordForgotForm" (ngSubmit)="onSubmit()">

        <mat-form-field>
            <input matInput [placeholder]="'EMAIL' | translate" formControlName="email" required>
            <mat-error *ngIf="submitted && f.email.errors && f.email.errors.required">{{'EMAIL_REQUIRED' | translate}}
            </mat-error>
            <mat-error *ngIf="submitted && f.email.errors && f.email.errors.email">{{'EMAIL_INVALID' | translate}}
            </mat-error>
        </mat-form-field>


        <div class="loginFormBottom">
            <button [disabled]="loading" class="btn btn-outline-light">
                <app-progressbar *ngIf="loading"></app-progressbar>
                {{'SEND' | translate}}
            </button>

            <br/>

            <a class="password-forgot" routerLink="/" routerLinkActive="" placement="bottom"
               [ngbTooltip]="'RETURN_TO_LOGIN_TOOLTIP' | translate" [innerHtml]="'RETURN_TO_LOGIN' | translate">Return to the login page</a>
            <br clear="right"/>
        </div>


    </form>
</div>